module.exports = "/_next/static/resources/photo-beth-c3a8fa9d495df60e8f21ed0d0499d911.webp";